/**
 * Backend API base URL for REST calls.
 * - Default: same origin + Vite `base`, with `/api` prefix (dev proxy or production router).
 * - Optional `VITE_API_BASE_URL`: full origin of the API server (e.g. http://localhost:8080) when the UI is not proxied.
 */
export function getApiOrigin(): string | null {
  const raw = import.meta.env.VITE_API_BASE_URL?.trim();
  if (!raw) return null;
  return raw.replace(/\/+$/, "");
}

export function apiUrl(path: string): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  const withApi = p.startsWith("/api") ? p : `/api${p}`;
  const origin = getApiOrigin();
  if (origin) return `${origin}${withApi}`;
  const viteBase = import.meta.env.BASE_URL?.replace(/\/+$/, "") || "";
  return `${viteBase}${withApi}`;
}
